<template>
  <div class="faq-with-toolbar">
    <v-container fluid class="toolbar">
      <v-row class="child-flex">
        <v-toolbar flat>
          <div class="toolbar-title text-left">
            <button class="btn" @click="closeIOSWebView">Back</button>
          </div>
          <div class="toolbar-title text-center mx-auto">
            {{ $t('tutorial','title') }}
          </div>
        </v-toolbar>
      </v-row>
    </v-container>
    <div class="fido-manual faq-page faq-page-container">
      <div v-for="(section, i) in tutorialSections" :key="`tutorial-${i}`">
        <h2><strong>{{ section.title }}</strong></h2>

        <template v-for="(item, j) in section.contents" :key="`tutorial-${i}-line-${j}`">
          <p v-if="item.type === 'text'" v-html="item.text"></p>

          <ol v-else-if="item.type === 'orderlist'">
            <li v-for="(line, k) in item.items" :key="k">
              <strong v-if="line.bold" v-html="line.bold"></strong>
              <span v-if="line.text" v-html="line.text"></span>
            </li>
          </ol>

          <ul v-else-if="item.type === 'list'">
            <li v-for="(line, k) in item.items" :key="k">
              <strong v-if="line.bold" v-html="line.bold"></strong>
              <span v-if="line.text" v-html="line.text"></span>
            </li>
          </ul>

          <img v-else-if="item.type === 'image'" :src="item.src" :alt="item.alt" class="faq-image mb-3" loading="lazy" />

          <iframe
            v-else-if="item.type === 'video'"
            :src="item.src"
            allowfullscreen
            class="img-fluid mb-3"
            frameborder="0"
            loading="lazy"
          ></iframe>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TutorialPanel',
  computed: {
    tutorialSections() {
      const raw = this.$t('tutorial','sections');
      return Object.values(raw);
    }
  },
  methods: {
    closeIOSWebView() {
      if (typeof window.webkit !== 'undefined' &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.unityCloseWebView) {
        console.log("closeIOSWebView");
        window.webkit.messageHandlers.unityCloseWebView.postMessage(null);
      } else {
        console.log("Not in iOS WKWebView or handler not registered.");
      }
    }
  }
}
</script>

<style scoped>
.fido-manual {
  padding: 40px;
  max-width: 960px;
  margin: 0 auto;
}
.faq-page-container h2 {
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 16px;
}
.faq-page-container ol,
.faq-page-container ul {
  margin-bottom: 24px;
  padding-left: 20px;
  text-align: left;
}
.faq-page-container p {
  margin-bottom: 16px;
  line-height: 1.8;
  text-align: left;
}
.faq-image {
  max-width: 100%;
  height: auto;
  margin: 16px 0;
  display: block;
}
.btn {
  padding: 6px 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.btn:hover {
  background-color: #0056b3;
}
</style>
